import React from "react";
import "./Next_Gen.css";
import { Link } from "react-router-dom";

const items = [
  {
    img: "/assets/images/home/next_gen/market_manage.png",
    title: "Marketing ",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/hostpital.png",
    title: "Hospital Administration and",
    subtitle: "Health Care Management",
  },
  {
    img: "/assets/images/home/next_gen/spec3.png",
    title: "Finance",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/time.png",
    title: "IT",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/spec55.png",
    title: "Project",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/spec66.png",
    title: "Operations ",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/human.png",
    title: "Human Resource ",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/international_buisness.png",
    title: "International Business",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/money-management.png",
    title: "Fintech",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/data.png",
    title: "Business Analytics ",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/nip.png",
    title: "Artificial Intelligence & Machine",
    subtitle: "Learning Management",
  },
  {
    img: "/assets/images/home/next_gen/materials-logistics.png",
    title: "Logistics Materials & Supply ",
    subtitle: "Chain Management",
  },
  {
    img: "/assets/images/home/next_gen/blockchain.png",
    title: "Blockchain",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/bullhorn.png",
    title: "Digital Marketing ",
    subtitle: "Management",
  },
  {
    img: "/assets/images/home/next_gen/agronomy.png",
    title: "AgriBusiness",
    subtitle: "Management",
  },
];

const Next_Gen = () => {
  return (
    <section className="next_gen">
      <div className="container">
        <div className="widget-title">
          <h3 className="nextgen_title">
            Choose from multiple
            <span className="white_txt"> Next-Gen Specializations </span>
          </h3>
        </div>

        <div className="row">
          {items.map((item, index) => (
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-6 mb-3 custom_col">
              <div className="next_gen_content text-center">
                <div className="next_icon">
                  <img src={item.img} alt={item.title} />
                </div>
                <p>{item.title}</p>
                <p>{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center">
          <Link
            to="/"
            className="know_btn mt-0"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Know More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Next_Gen;
